import nameof from 'ts-nameof.macro';
import { url } from 'core/helpers/string';
import { Repository } from 'core/repositories/Repository';
import kebabCase from 'lodash/kebabCase';
import { httpConfig } from 'config/http';
import { API_BASE_URL } from 'core/config';

import { API_AUTHENTICATION_ROUTE } from 'config/api-consts';
import { LoginConfiguration } from 'models/LoginConfiguration';
import { AxiosResponse } from 'axios';

export class LoginConfigurationRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.setBaseURL(url(API_BASE_URL, API_AUTHENTICATION_ROUTE));
  }

  public getAuthorizationEndpoint = (id:number): Promise<string> => {
    return this.http.post(`get-authorization-endpoint?loginConfigurationId=${id}`)
        .then((response: AxiosResponse<string>) => response.data);
    };

    public getLoginProfile = (): Promise<any> => {
        return this.http.post<any>
            (kebabCase(nameof(this.getLoginProfile)), undefined,

            )
            .then((response: AxiosResponse<any>) => response.data);
        };

        public login = (infomation:any): Promise<any> => {
          return this.http.post<any>
          (kebabCase(nameof(this.login)), infomation,

      )
            .then((response: AxiosResponse<any>) => response.data);
        };



}

export const loginConfigurationRepository: LoginConfiguration = new LoginConfigurationRepository();
